import type React from 'react';

import type { MessageDescriptor } from 'react-intl';

import { FlexColumn, Gap } from 'ui-components/components/flex';
import { MDash } from 'ui-components/components/mdash';
import { Text, TextType } from 'ui-components/components/text';

import styles from './detail-field.styles.module.less';

type DetailFieldProps = {
  label: MessageDescriptor;
  value: React.ReactNode;
  className?: string;
};

export const DetailField = ({ label, value, className }: DetailFieldProps) => {
  const hasValue = value !== undefined && value !== null && value !== '';

  return (
    <FlexColumn className={className} gap={Gap.Space4}>
      <Text textType={TextType.Label} value={label} />
      {hasValue ? <Text className={styles.value} textType={TextType.Paragraph} value={value} /> : <MDash />}
    </FlexColumn>
  );
};
